import React, { useState, useEffect } from 'react';
import { signOut } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Container, Nav, Navbar } from 'react-bootstrap';
import auth from '../../../firebase.init';
import { Link } from 'react-router-dom';
import CustomLink from '../../CustomLink/CustomLink';
import './Header.css';
import mosheurRahman from '../../../images/mosheur-rahman.jpg';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleSignOut = () => {
    signOut(auth);
  };

  return (
    <Navbar
      // className="mb-3"
      collapseOnSelect
      expand="lg"
      className={scrolled ? 'scrolled' : ''}
      variant="dark"
      sticky="top"
      style={
        scrolled ? { backdropFilter: 'blur(10px)', marginBottom: '30px' } : {}
      }>
      <Container>
        <Navbar.Brand as={Link} to="/">
          <img
            alt=""
            src={mosheurRahman}
            width="50"
            height="50"
            className="d-inline-block align-center rounded-circle nav-logo"
          />{' '}
          <b className="logo-title" style={{ color: 'white' }}>
            <span style={{ color: '#0000ff' }}>MOSHEUR</span>{' '}
            <span style={{ color: '#ccd6f6' }}>RAHMAN</span>
          </b>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav" className="text-center">
          <Nav className="ms-auto">
            <Nav.Link as={CustomLink} to="/home">
              Home
            </Nav.Link>
            <Nav.Link as={CustomLink} to="/allProjects" href="myAllPro">
              Projects
            </Nav.Link>
            <Nav.Link as={CustomLink} to="/experience">
              Experience
            </Nav.Link>
            <Nav.Link as={CustomLink} to="/contact">
              Contact
            </Nav.Link>
            {/* {user ? (
              <Nav.Link
                onClick={handleSignOut}
                className="text-decoration-none"
                style={{ color: "#fff" }}
              >
                <b>Log Out</b>
              </Nav.Link>
            ) : (
              <Nav.Link as={CustomLink} to="/login">
                Login
              </Nav.Link>
            )} */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
